import { IJsonQueryHighway } from '../../../../api-models/common/json_query';
import { TTagsManager } from '../../types/tag';
import { getGeoValueByType, setGeo } from '../../../../JsonQuery';
import { normalizeHighwaysData } from './utils';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'geoHighway' as const;

export const geoHighwayTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, geoTags }) => {
    const highways = getGeoValueByType<IJsonQueryHighway>('highway')(jsonQuery);

    if (highways === null) {
      return null;
    }

    const highwayIds = highways.map(({ id }) => id);
    const normalizedHighways = normalizeHighwaysData(highwayIds, geoTags.directions);

    return normalizedHighways.map(highway => ({
      label: highway.text,
      value: createTagValue(ID, highway.id.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const values = getGeoValueByType<IJsonQueryHighway>('highway')(jsonQuery);

    if (!values) {
      return jsonQuery;
    }

    const newValues = values.filter(({ id }) => String(id) !== removingTagValue);

    return setGeo()(jsonQuery)(newValues);
  },
};
